var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSessionStreamlineFlex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.645 -0.645 18 18",
    id: "Session--Streamline-Flex",
    height: 18,
    width: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Session Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "session--video-call-appointment",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.7 4.4h9.0a1.2 1.2 0 0 1 1.2 1.2v5.5a1.2 1.2 0 0 1 -1.2 1.2h-9.0a1.2 1.2 0 0 1 -1.2 -1.2V5.6a1.2 1.2 0 0 1 1.2 -1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9 8.355 15.6 6.0v4.71l-3.7 -2.355Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionStreamlineFlex);
export default __webpack_public_path__ + "static/media/Session--Streamline-Flex.fc7b9006e346767e1c07f6e355361746.svg";
export { ForwardRef as ReactComponent };